import { Field, Icon, Input, InputGroup } from "@chakra-ui/react"
import type { ChangeEvent } from "react"
import { FaSearch } from "react-icons/fa"

interface SearchFieldProps {
  inputValue: string
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const SearchField = ({
  inputValue,
  onInputChange,
}: SearchFieldProps) => {
  return (
    <Field.Root>
      <Field.Label fontSize={16}>Suche</Field.Label>
      <InputGroup 
        flex="1" 
        w={{ base: "full", md: "31%"}}
        css={{
          "& > div": {
            padding: "0 !important",
          },
        }}
        endElement={
          <Icon as={FaSearch} color="main" mr={2} />
        }>
        <Input
          w="full"
          name="Suche"
          placeholder="Suche"
          _focus={{
            borderColor: "main"
          }}
          value={inputValue}
          onChange={onInputChange}
        />
      </InputGroup>
    </Field.Root>
  )
}

export default SearchField
